/**
 * Presentational: "Set Facility Standards" card with heading and FacilityStandardsPanel.
 * Single Responsibility: layout and heading; panel receives props from parent.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FacilityStandardsPanel } from '../../../components/standards/FacilityStandardsPanel';
import { PAGE_COPY, PANEL_CARD_CLASS } from '../constants';

const HEADING_CLASS =
  'font-[\'Roboto:SemiBold\',sans-serif] font-semibold text-lg text-black mb-4';

export function FacilityStandardsSection({
  facilityIds,
  facilityNames,
  onStandardsChange,
  heading = PAGE_COPY.FACILITY_STANDARDS_HEADING,
}) {
  return (
    <div className={`${PANEL_CARD_CLASS} p-6 min-h-[200px]`}>
      <h2 className={HEADING_CLASS}>{heading}</h2>
      <FacilityStandardsPanel
        facilityIds={facilityIds}
        facilityNames={facilityNames}
        onStandardsChange={onStandardsChange}
      />
    </div>
  );
}

FacilityStandardsSection.propTypes = {
  facilityIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  facilityNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  onStandardsChange: PropTypes.func,
  heading: PropTypes.string,
};
